// Visual Effects: Confetti

function createConfetti() {
    const confettiContainer = document.getElementById('confettiContainer');
    // Get current theme color from CSS variable
    const currentThemeColor = getComputedStyle(document.documentElement).getPropertyValue('--accent-color').trim();
    const colors = [currentThemeColor, currentThemeColor, '#FF4444', '#00FF66', '#0055AA', '#FF1493'];

    for (let i = 0; i < 50; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';
        confetti.style.left = Math.random() * 100 + '%';
        confetti.style.background = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animationDuration = (Math.random() * 3 + 2) + 's';
        confetti.style.animationDelay = (Math.random() * 0.5) + 's';

        confettiContainer.appendChild(confetti);

        // Remove confetti after animation
        setTimeout(() => {
            confetti.remove();
        }, 5000);
    }
}

export { createConfetti };
